import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledPinIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.1129 3.20995L15.2069 3.29295L20.7069 8.79295C20.8755 8.96242 20.9778 9.18668 20.9952 9.42507C21.0127 9.66347 20.9442 9.90025 20.8021 10.0925C20.6601 10.2847 20.4538 10.4197 20.2208 10.473C19.9878 10.5263 19.7434 10.4943 19.5319 10.3829L16.3599 13.5539L14.9359 17.3509C14.8984 17.4511 14.845 17.5447 14.7779 17.6279L14.7079 17.7079L13.2079 19.2079C13.0356 19.38 12.8064 19.4832 12.5634 19.4983C12.3204 19.5134 12.0802 19.4393 11.8879 19.2899L11.7929 19.2069L8.99988 16.4149L5.20688 20.2069C5.02693 20.3863 4.78545 20.4904 4.5315 20.4982C4.27755 20.5059 4.03017 20.4167 3.83961 20.2487C3.64904 20.0807 3.52958 19.8464 3.50549 19.5935C3.48139 19.3405 3.55447 19.0879 3.70988 18.8869L3.79288 18.7929L7.58488 14.9999L4.79288 12.2069C4.62071 12.0348 4.51728 11.8057 4.502 11.5626C4.48671 11.3196 4.56063 11.0793 4.70988 10.8869L4.79288 10.7929L6.29288 9.29295C6.36834 9.21722 6.45544 9.15409 6.55088 9.10595L6.64888 9.06395L10.4449 7.63895L13.6159 4.46895C13.5078 4.26678 13.4724 4.03359 13.5157 3.80845C13.559 3.58331 13.6783 3.37988 13.8537 3.23224C14.0291 3.08461 14.25 3.00172 14.4792 2.99748C14.7084 2.99324 14.9321 3.0689 15.1129 3.20995Z",
		fill: "#333333"
	})]
});
const ForwardRef = forwardRef(SvgFilledPinIcon);
const Memo = memo(ForwardRef);
export default Memo;
